// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-MhM2OB","tab":"tab-VwQt4F","active":"active-Th5Qj8"};